module.exports = __webpack_public_path__ + "static/media/godaddy.9ca8c72c.svg";